module.exports = __webpack_public_path__ + "static/image_4_thumb-eab8619a2cdafa693ab88d4f6a477a77.jpg";